(() => {
  const desktopQuery = window.matchMedia('(min-width: 1025px)');
  const recommendationsSelector = 'product-recommendations';
  let originMarker;
  let frame;

  const getRail = () => {
    const galleryColumn = document.querySelector('.iphone17-product-pilot .aside-content');
    if (!galleryColumn) return null;

    let rail = galleryColumn.querySelector('[data-iphone17-left-rail]');
    if (!rail) {
      rail = document.createElement('div');
      rail.className = 'iphone17-product-pilot__left-rail';
      rail.dataset.iphone17LeftRail = '';
      galleryColumn.appendChild(rail);
    }
    return rail;
  };

  const updateCarousel = (recommendations) => {
    window.requestAnimationFrame(() => {
      recommendations.querySelector('.swiper-container')?.swiper?.update();
    });
  };

  const arrangeRecommendations = () => {
    const rail = getRail();
    const recommendations = document.querySelector(recommendationsSelector);
    if (!rail || !recommendations) return;

    if (!originMarker?.isConnected) {
      originMarker = document.createElement('span');
      originMarker.hidden = true;
      originMarker.dataset.iphone17RecommendationsOrigin = '';
      recommendations.parentNode.insertBefore(originMarker, recommendations);
    }

    if (desktopQuery.matches) {
      if (recommendations.parentNode !== rail) rail.appendChild(recommendations);
    } else if (originMarker.parentNode && recommendations.previousSibling !== originMarker) {
      originMarker.parentNode.insertBefore(recommendations, originMarker.nextSibling);
    }

    updateCarousel(recommendations);
  };

  const scheduleArrangement = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(arrangeRecommendations);
  };

  const start = () => {
    arrangeRecommendations();
    desktopQuery.addEventListener('change', scheduleArrangement);
    document.addEventListener('shopify:section:load', scheduleArrangement);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
